import { WriterSection } from './WriterSection'
import { withWriterSection } from './withWriterSection'

const ConnectedWriterSection = withWriterSection(WriterSection)
export { ConnectedWriterSection as WriterSection }
